import * as React from "react";
import {useState} from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {ContainerBox} from "myshubhlife-component/container-box";
import {ACCEPT_TYPE, COLOR} from "utils/variables";
import {IScreens} from "IncompleteInfoV2/interface";
import {pageTitle, ScreenNames} from "IncompleteInfoV2/utils";
import SelfieCapture from "selfie";
import DocInput, {DocTypes} from "myshubhlife-component/docInput";
import {getContentType} from "userform/utils";
import {DocUploadModes} from "loan-application/utils";
import {updateSubStatuses, uploadDocument} from "IncompleteInfoV2/api";
import {history} from "load/store";
import {removeCompletedSubStatus, showToast} from "IncompleteInfoV2/actions";
import Loading from "components/loading";
import "./style.scss";
import {isMobileOrTab} from "utils";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    screens: IScreens;
    isAndroid: boolean;
    applicationId: number;
}

const SelfieUpload = (props: IConnectProps & RouteComponentProps) => {
    const [loading, setLoading] = useState(false);
    const [isUploaded, setIsUploaded] = useState(false);
    const handleFileUpload = async (imageB64: string, docType: DocTypes) => {
        if (!docType) {
            docType = DocTypes.SELFIE;
        }
        const fileType = getContentType(imageB64);
        const docPayload = {
            imageB64,
            userId: props.userId,
            docMode: DocUploadModes.SCAN_UPLOAD,
            docType,
            contentType: fileType.mime,
        };
        setLoading(true);
        try {
            const uploadResponse = await uploadDocument(docType, docPayload);
            if (uploadResponse.status === 200) {
                setIsUploaded(true);
                const removeSubStatus = await updateSubStatuses(props.applicationId, props.screens[ScreenNames.SELFIE_UNCLEAR].subStatuses);
                if (removeSubStatus.status === 200) {
                    props.dispatch(showToast(COLOR.GREEN, `${pageTitle.selfie} updated successfully`));
                    props.dispatch(removeCompletedSubStatus(ScreenNames.SELFIE_UNCLEAR));
                    setLoading(false);
                    history.goBack();
                }
            }
        } catch (e) {
            setLoading(false);
        }
    };
    return (
        <ContainerBox
            backgroundColor={COLOR.WHITE}
            pageTitle={pageTitle.selfie}
            showBackButton={!props.isAndroid}
        >
            <Loading active={loading} msg="Please wait while uploading"/>
            <div className="doc-upload-container">
                {
                    props.isAndroid || isMobileOrTab() ?
                        <DocInput
                            primaryLabel={"Selfie Capture"}
                            type={DocTypes.SELFIE}
                            handleFileInput={handleFileUpload}
                            compressionRequired={true}
                            captureType={"capture"}
                            isUploaded={isUploaded}
                            acceptType={`${ACCEPT_TYPE.JPG},${ACCEPT_TYPE.PNG},${ACCEPT_TYPE.JPEG}`}
                        /> :
                        <SelfieCapture onSubmit={handleFileUpload} />

                }
            </div>
        </ContainerBox>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        userId: state.login.auth.userId,
        screens: state.incompleteInfoV2.screens,
        isAndroid: state.login.isAndroid,
        applicationId: state?.profileInfo?.latestStatus?.applicationId,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(SelfieUpload);
